import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Requisites' })((theme) => ({
    main: {
        display: 'flex',
        gap: 80,
        marginTop: 32,
        flexWrap: 'wrap',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            flexDirection: 'column',
            gap: 12
        }
    },
    grid: {
        display: 'grid',
        flex: 1,
        gridTemplateColumns: '1fr 1fr',
        columnGap: 8,
        rowGap: 12
    },
    text: {
        color: '#8E8E8E',
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.54px',
        whiteSpace: 'nowrap'
    },
    name: {
        textAlign: 'left'
    },
    value: {
        textAlign: 'right',
        color: '#fff'
    }
}));
